import {types} from "mobx-state-tree";
import {DashboardStore} from "../../stores/domain/DashboardStore";
import {codeBehavior} from "../../utils/constants";
import Notification from "../../utils/Notification";


export const DashboardViewState = types.model('DashboardViewState', {
  appsStore : types.maybe(types.late(() => types.reference(DashboardStore))),
  selectedExperience: types.optional(types.string, '')
}).actions((self) => ({
  setSelectedExperience(experience, staticBehaviorEnabled) {
    // Check if the experience has only static behavior
    const hasOnlyStatic = experience.behavior?.length === 1 && experience.behavior.includes(codeBehavior.STATIC);

    // If experience has only static behavior, check if tenant feature is enabled
    if (hasOnlyStatic && !staticBehaviorEnabled) {
      new Notification()
        .setType("info")
        .setTitle("Static feature disabled")
        .setMessage("STATIC behavior is not enabled for the tenant. Cannot select this experience.")
        .send();

      // Block the selection - return false
      return false;
    }

    // Set the selected experience
    self.selectedExperience = experience.name;

    // Return true to allow the selection
    return true;
  },
}))

